import angular from 'angular';
import customerCareInterestOnlyExpiry from './customerCareInterestOnlyExpiry';

export default angular.module('customerCareTab.scenes', [
  customerCareInterestOnlyExpiry,
]).name;
